import { FaCalendar, FaCalendarAlt, FaCodeBranch, FaLaptop, FaEye, FaEyeSlash, FaSearch, FaBell, FaUsers, FaRegQuestionCircle } from "react-icons/fa";
import { HiOutlineUser } from "react-icons/hi";
import { RxDashboard } from "react-icons/rx";
import { FaGear, FaCodePullRequest } from "react-icons/fa6";
import { GiHamburgerMenu, GiGymBag, GiHotMeal } from "react-icons/gi";
import { PiBowlFoodFill } from "react-icons/pi";
import { BsSortUp, BsSortDownAlt } from "react-icons/bs";
import {
  MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight, MdOutlineKeyboardArrowDown, MdOutlineModeEdit, MdOutlineDomain,
  MdOutlineRemoveRedEye, MdFilterList, MdOutlineCameraAlt, MdOutlineFingerprint, MdOutlineLogout, MdOutlineVideoSettings,
  MdOutlineKeyboardArrowUp, MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight
  , MdSignalWifiStatusbarConnectedNoInternet1, MdNoMeals, MdFormatListBulleted, MdOutlineAdminPanelSettings, MdOutlineDevices,
} from "react-icons/md";
import { RiDeleteBinLine, RiCalendarScheduleLine } from "react-icons/ri";
import { FiPlus, FiUser } from "react-icons/fi";
import { IoImageOutline, IoPeopleOutline } from "react-icons/io5";
import { LiaPeopleCarrySolid } from "react-icons/lia";
import { TbLockAccess } from "react-icons/tb";
import { CgGym } from "react-icons/cg";
import { IoQrCode } from "react-icons/io5";
import { MdOutlineSendToMobile } from "react-icons/md";
import { FaMobileAlt } from "react-icons/fa";
import { FaStore } from "react-icons/fa";
import { AiOutlineProduct } from "react-icons/ai";
import { FaCartArrowDown } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";

const iconMap = {
  MdOutlineSendToMobile,
  TbLockAccess,
  IoQrCode,
  PiBowlFoodFill,
  RxDashboard,
  MdNoMeals,
  HiOutlineUser,
  FaCalendar,
  FaCalendarAlt,
  FaLaptop,
  GiGymBag,
  CgGym,
  FaUsers,
  FaGear,
  FiPlus,
  FaEye,
  FiUser,
  FaBell,
  FaSearch,
  FaEyeSlash,
  FaCodeBranch,
  TbLockAccess,
  IoPeopleOutline,
  MdOutlineDomain,
  GiHamburgerMenu,
  IoImageOutline,
  MdOutlineDevices,
  FaCodePullRequest,
  FaRegQuestionCircle,
  LiaPeopleCarrySolid,
  MdFormatListBulleted,
  RiCalendarScheduleLine,
  MdOutlineVideoSettings,
  MdOutlineKeyboardArrowLeft,
  MdOutlineAdminPanelSettings,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
  MdSignalWifiStatusbarConnectedNoInternet1,
  RiDeleteBinLine,
  MdOutlineModeEdit,
  MdOutlineRemoveRedEye,
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
  MdFilterList,
  MdOutlineCameraAlt,
  MdOutlineFingerprint,
  MdOutlineLogout,
  BsSortDownAlt,
  BsSortUp,
  GiHotMeal,
  FaMobileAlt,
  FaStore,
  AiOutlineProduct,
  FaCartArrowDown,
  FaChartLine 
};

const GetIcon = ({ iconName, size = 23, color = "", design = '', child = '', action = () => { } }) => {
  const IconComponent = iconMap[iconName];
  return IconComponent ? <IconComponent size={size} color={color} children={child} onClick={action} className={design} /> : null

};

export default GetIcon;
